const config = {
  contentful: {
    accessToken: 'oKnPnLrgUVk8H5JkQYwXnmRDqoHO33--BzmTxPpRcfw',
    space: '9y4fi2gkk4ov',
    environment: 'master',
  },
  nacelle: {
    accessToken: '46f88cd6-c61a-4eb3-b173-023d71bd108e',
    endpoint:
      'https://storefront.api.nacelle.com/graphql/v1/spaces/2a44c2f6-6513-4ceb-9530-489670be5b21',
  },
  ninetailed: {
    previewPlugin: {
      clientId: '79e33a8f-9ff5-4ef2-963f-9865902d9904',
      secret: '5e0906fa-08d5-4271-9848-e3e4bfa08086',
    },
    provider: {
      clientId: '959454bc-e4e6-4088-9861-937af542b86e',
      environment: 'main',
    },
  },
  searchspring: {
    siteId: 'thyt6y',
  },
  trustpilot: {
    url: 'https://au.trustpilot.com/review/ruggable.com.au',
    businessId: '627e8a4e911105d1338fbc03',
  },
  defaultLocale: 'en-AU',
};

export default config;
